import React from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { DateChangeEntry } from '../../types';

interface ChangeHistoryModalProps {
  active: boolean;
  onClose: () => void;
  fieldLabel: string;
  history: DateChangeEntry[];
}

const ChangeHistoryModal: React.FC<ChangeHistoryModalProps> = ({ active, onClose, fieldLabel, history }) => {
  const filtered = history.filter((h) => h.label === fieldLabel);

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-sm">
        <div className="modal-header">
          <h2>Change History — {fieldLabel}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div style={{ padding: '1rem 1.5rem' }}>
          {filtered.length === 0 ? (
            <p style={{ color: 'var(--text-dim)' }}>No changes recorded.</p>
          ) : (
            filtered.map((entry, i) => (
              <div key={i} className="change-history-entry">
                <div className="ch-timestamp">{new Date(entry.timestamp).toLocaleString()}</div>
                <div className="ch-dates">{entry.old_value || 'empty'} &rarr; {entry.new_value || 'empty'}</div>
                <div className="ch-reason">{entry.reason}</div>
              </div>
            ))
          )}
        </div>
        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default ChangeHistoryModal;
